import React from "react";
import { Box, InputAdornment, IconButton } from "@mui/material";
import { Controller, } from "react-hook-form";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Clock } from "iconsax-react";
export const FTimePicker = ({ name, control, label, disabled = false, backgroundColor = "transparent", size = "medium", rules, minTime, }) => {
    const [open, setOpen] = React.useState(false);
    const handleIconClick = () => {
        setOpen(true);
    };
    return (React.createElement(Box, { width: "100%" },
        React.createElement(Controller, { name: name, control: control, rules: rules, render: ({ field, fieldState }) => {
                var _a;
                return (React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
                    React.createElement(TimePicker, { sx: {
                            width: "100%",
                            background: backgroundColor,
                        }, open: open, onClose: () => setOpen(false), disabled: disabled, label: label, format: "HH:mm", ampm: false, value: field.value ? dayjs(field.value) : null, minTime: minTime, closeOnSelect: true, onChange: (time) => {
                            let parsedTime = null;
                            if (time && typeof time.toDate === "function") {
                                parsedTime = time.toDate();
                            }
                            else if (time instanceof Date) {
                                parsedTime = time;
                            }
                            else {
                                parsedTime = null;
                            }
                            field.onChange(parsedTime);
                        }, enableAccessibleFieldDOMStructure: false, slotProps: {
                            textField: {
                                variant: "filled",
                                fullWidth: true,
                                error: !!fieldState.error,
                                helperText: (_a = fieldState.error) === null || _a === void 0 ? void 0 : _a.message,
                                size,
                                onClick: handleIconClick,
                                InputProps: {
                                    endAdornment: (React.createElement(InputAdornment, { position: "end" },
                                        React.createElement(IconButton, { edge: "end", size: "small", onClick: handleIconClick, sx: { width: 32, height: 32 } },
                                            React.createElement(Clock, { size: 20, color: "#00244D" })))),
                                },
                            },
                        } })));
            } })));
};
